/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const CellRange = require('../../model/CellRange');
const Selection = require('../../model/Selection');
const { getStreamSheetId } = require('./sheet');

const newCellRange = (sheet, range) => new CellRange(
	sheet,
	range.x1,
	range.y1,
	range.x2,
	range.y2,
	range.x1R,
	range.y1R,
	range.x2R,
	range.y2R
);

const toCellRange = (range, graph) => {
	const sheet = graph.getItemById(range.id);
	return sheet ? newCellRange(sheet, range) : undefined;
};
const toCellRanges = (ranges, graph) => {
	const sheet = graph.getItemById(ranges[0].id);
	return sheet ? ranges.map(range => newCellRange(sheet, range)) : undefined;
};

const rangeAsString = (range, shiftIt = true) => (shiftIt ? range.shiftToSheet().toString() : range.toString());
const getRangeIndex = (range, shiftIt) => rangeAsString(range, shiftIt).split(':')[0];
const getCellReference = (range, shiftIt = true) => {
	if (shiftIt) range.shiftToSheet();
	return { col: range.getColumnString(range.getX1()), row: range.getY1() + 1 };
};
const toCellsColsRows = (ranges, sheet) => {
	const tmprange = new CellRange(sheet, 0, 0, 0, 0);
	const spreaded = { cells: [], cols: [], rows: [], sheet: undefined };
	// is it possible to set properties for different sheets?
	ranges.forEach((range) => {
		if (range.isSheetRange()) {
			spreaded.sheet = { id: getStreamSheetId(range.sheet) };
		} else if (range.isColumnRange()) {
			range.enumerateColumns((index) => {
				const col = getRangeIndex(tmprange.set(index, 1, index, sheet.maxRows));
				spreaded.cols.push({ index, ref: { col } });
			});
		} else if (range.isRowRange()) {
			range.enumerateRows((index) => {
				const row = getRangeIndex(tmprange.set(1, index, sheet.maxColumns, index));
				spreaded.rows.push({ index, ref: { row } });
			});
		} else {
			range.enumerateCells(false, (pos) => {
				const ref = getCellReference(tmprange.set(pos.x, pos.y));
				spreaded.cells.push({ ref });
			});
		}
	});
	return spreaded;
};

const getCellRangesFromSelection = (ref, sheet) => {
	const selection = Selection.fromStringMulti(ref, sheet);
	return selection ? selection._ranges : [];
};

const getCellsInRanges = (ranges, sheet) => {
	const cells = [];
	const data = sheet.cells;
	const tmprange = new CellRange(sheet, 0, 0, 0, 0);
	ranges.forEach((range) => {
		range.enumerateCells(false, (pos) => {
			const cell = data.get(pos);
			const ref = getCellReference(tmprange.set(pos.x, pos.y));
			const reference = `${ref.col}${ref.row}`;
			cells.push({ ref, reference, cell });
		});
	});
	return cells;
};
const enumerateRangesColumns = (ranges, sheet, callback) => {
	const tmprange = new CellRange(sheet, 0, 0, 0, 0);
	ranges.forEach((range) => {
		for (let index = range._x1; index <= range._x2; index += 1) {
			const col = getRangeIndex(tmprange.set(index, 1, index, sheet.maxRows));
			callback(index, col, range);
		}
	});
};
const enumerateRangesRows = (ranges, sheet, callback) => {
	const tmprange = new CellRange(sheet, 0, 0, 0, 0);
	ranges.forEach((range) => {
		for (let index = range._y1; index <= range._y2; index += 1) {
			const row = getRangeIndex(tmprange.set(1, index, sheet.maxColumns, index));
			callback(index, row, range);
		}
	});
};
module.exports = {
	enumerateRangesColumns,
	enumerateRangesRows,
	getCellReference,
	getCellsInRanges,
	getCellRangesFromSelection,
	getRangeIndex,
	toCellRange,
	toCellRanges,
	toCellsColsRows
};
